export const comicDetail = {
  id: 'comic-1',
  title: '剑与魔法',
  titleKo: '검과 마법',
  cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20fantasy%20adventure%20cover%20art%20featuring%20a%20warrior%20with%20sword%20and%20magical%20energy%2C%20dramatic%20lighting%2C%20epic%20composition%2C%20detailed%20illustration%2C%20warm%20golden%20and%20dark%20tones%2C%20professional%20comic%20cover%20design&width=400&height=560&seq=detail-cover-01&orientation=portrait',
  heroImage: 'https://readdy.ai/api/search-image?query=Epic%20Korean%20manhwa%20style%20fantasy%20battle%20scene%2C%20warrior%20wielding%20glowing%20sword%20against%20dark%20dragon%2C%20dramatic%20golden%20light%2C%20ancient%20ruins%20background%2C%20cinematic%20composition%2C%20detailed%20illustration%2C%20epic%20scale&width=1600&height=700&seq=detail-hero-01&orientation=landscape',
  rating: 9.6,
  reads: '1.2亿',
  status: 'ongoing',
  genres: ['奇幻', '动作', '冒险'],
  author: '金泰浩',
  artist: '朴志勋',
  chapterCount: 187,
  lastUpdate: '2026-07-02',
  description: '在一个魔法与剑术并存的世界里，平凡少年艾伦意外获得传说中的圣剑，踏上了成为最强剑士的征程。面对黑暗势力的威胁，他必须与伙伴们一起守护这个世界的和平。宏大的世界观、精彩绝伦的战斗场面、感人至深的友情与羁绊——这是一部不容错过的奇幻史诗巨作。作品自连载以来，凭借精湛的画风和扣人心弦的剧情，收获了大量读者的喜爱，长期占据各大榜单前列。',
  chapters: [
    { num: 187, title: '最终的抉择', date: '2026-07-02', isNew: true },
    { num: 186, title: '黑暗降临', date: '2026-06-28', isNew: false },
    { num: 185, title: '援军到来', date: '2026-06-25', isNew: false },
    { num: 184, title: '绝境之战', date: '2026-06-21', isNew: false },
    { num: 183, title: '王都沦陷', date: '2026-06-18', isNew: false },
    { num: 182, title: '背叛者', date: '2026-06-14', isNew: false },
    { num: 181, title: '秘密揭示', date: '2026-06-11', isNew: false },
    { num: 180, title: '潜入敌营', date: '2026-06-07', isNew: false },
  ],
  reviews: [
    {
      id: 'dr-1',
      text: '这部漫画的世界观设定太宏大了！每个角色都有血有肉，战斗分镜震撼力十足，是目前看过最好的韩漫奇幻作品。',
      author: '剑心永恒',
      avatar: 'https://readdy.ai/api/search-image?query=Korean%20style%20anime%20portrait%20avatar%2C%20young%20man%20with%20determined%20expression%2C%20simple%20warm%20background%2C%20clean%20illustration%20style%2C%20professional%20headshot&width=80&height=80&seq=avatar-dr-01&orientation=squarish',
      rating: 5,
      date: '2026-07-01',
      likes: 2341,
    },
    {
      id: 'dr-2',
      text: '每周都在等更新！画风真的很顶，特别是魔法特效的处理方式，每次看都觉得很震撼。剧情也越来也精彩了。',
      author: '魔法学徒',
      avatar: 'https://readdy.ai/api/search-image?query=Korean%20style%20anime%20portrait%20avatar%2C%20young%20woman%20with%20curious%20eyes%2C%20simple%20warm%20background%2C%20clean%20illustration%20style%2C%20professional%20headshot&width=80&height=80&seq=avatar-dr-02&orientation=squarish',
      rating: 5,
      date: '2026-06-30',
      likes: 1856,
    },
    {
      id: 'dr-3',
      text: '从第一章追到现在，见证了主角的成长，真的很有代入感。强烈推荐给所有喜欢热血奇幻的朋友！',
      author: '追漫达人',
      avatar: 'https://readdy.ai/api/search-image?query=Korean%20style%20anime%20portrait%20avatar%2C%20mature%20man%20with%20thoughtful%20expression%2C%20simple%20dark%20background%2C%20clean%20illustration%20style%2C%20professional%20headshot&width=80&height=80&seq=avatar-dr-03&orientation=squarish',
      rating: 4,
      date: '2026-06-28',
      likes: 1203,
    },
  ],
};

export const comicDetail2 = {
  id: 'comic-2',
  title: '甜蜜陷阱',
  titleKo: '달콤한 함정',
  cover: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20cover%20art%20featuring%20a%20beautiful%20couple%20in%20soft%20embrace%2C%20pastel%20pink%20and%20warm%20tones%2C%20romantic%20atmosphere%2C%20delicate%20linework%2C%20professional%20webtoon%20cover%20style%2C%20clean%20composition&width=400&height=560&seq=detail-cover-02&orientation=portrait',
  heroImage: 'https://readdy.ai/api/search-image?query=Romantic%20Korean%20manhwa%20style%20scene%2C%20beautiful%20couple%20walking%20under%20cherry%20blossoms%20in%20spring%2C%20soft%20pink%20petals%20falling%2C%20warm%20golden%20sunset%20light%2C%20dreamy%20atmosphere%2C%20cinematic%20composition%2C%20delicate%20illustration&width=1600&height=700&seq=detail-hero-02&orientation=landscape',
  rating: 9.3,
  reads: '8900万',
  status: 'ongoing',
  genres: ['恋爱', '日常'],
  author: '李恩珠',
  artist: '崔美妍',
  chapterCount: 124,
  lastUpdate: '2026-07-03',
  description: '高冷女总裁和温柔咖啡师之间甜蜜又爆笑的爱情故事。一个是商界女强人，一个是热爱生活的暖男，两个完全不同世界的人因为一杯咖啡而相遇，从此展开了一段令人心动的浪漫旅程。细腻的情感描写、精美的画面呈现，让每一位读者都能感受到恋爱的甜蜜滋味。',
  chapters: [
    { num: 124, title: '告白之夜', date: '2026-07-03', isNew: true },
    { num: 123, title: '心动的瞬间', date: '2026-06-30', isNew: false },
    { num: 122, title: '意外的相遇', date: '2026-06-27', isNew: false },
    { num: 121, title: '雨中的约定', date: '2026-06-24', isNew: false },
    { num: 120, title: '误会与和解', date: '2026-06-21', isNew: false },
  ],
  reviews: [
    {
      id: 'dr2-1',
      text: '男女主的人设太讨喜了！高冷女总裁和温柔咖啡师这种反差萌简直绝了，每集都甜到爆炸。',
      author: '甜控患者',
      avatar: 'https://readdy.ai/api/search-image?query=Korean%20style%20anime%20portrait%20avatar%2C%20young%20woman%20with%20bright%20smile%2C%20simple%20pink%20background%2C%20clean%20illustration%20style%2C%20professional%20headshot&width=80&height=80&seq=avatar-dr2-01&orientation=squarish',
      rating: 5,
      date: '2026-07-02',
      likes: 3201,
    },
    {
      id: 'dr2-2',
      text: '画风太美了，特别是那些浪漫场景的描绘，每一格都可以截下来当壁纸。剧情也很上头！',
      author: '壁纸收藏家',
      avatar: 'https://readdy.ai/api/search-image?query=Korean%20style%20anime%20portrait%20avatar%2C%20artist%20girl%20with%20beret%2C%20simple%20warm%20background%2C%20clean%20illustration%20style%2C%20professional%20headshot&width=80&height=80&seq=avatar-dr2-02&orientation=squarish',
      rating: 5,
      date: '2026-07-01',
      likes: 2789,
    },
  ],
};